import { RadioGroup } from "../atoms/radio-group";
import { createFormField } from "./input-field";

export const RadioGroupField = createFormField(RadioGroup);
